import React from 'react';
import { CATEGORIES } from '../components/menu-page/CategorySidebar';
import { ShortCutAnnouncementData } from './ShortcutAnnouncement';
import { ThemingAnnouncementData } from './ThemingAnnouncement';
import { ContextMenuAnnouncementData } from './ContextMenuAnnouncement';

export interface AnnouncementCoreData {
	title: string;
	content: React.ReactElement;
	tags: CATEGORIES[];
	isPcmGated?: boolean;
	media?: {
		type: 'image';
		url: { default: string };
		alt?: string;
	};
	links?: Array<{
		text: string;
		url: string;
	}>;
}

export interface AnnouncementData extends AnnouncementCoreData {
	id: string;
	date: string;
}

export const announcements: AnnouncementData[] = [
	{
		id: 'announcement-2026-08-11',
		date: '2026-08-11',
		isPcmGated: true,
		...ContextMenuAnnouncementData,
	},
	{
		id: 'announcement-2025-06-17',
		date: '2025-06-17',
		...ThemingAnnouncementData,
	},
	{
		id: 'announcement-2025-03-25',
		date: '2025-03-25',
		...ShortCutAnnouncementData,
	},
];

// Note for developers:
/*
When adding new announcements:
1. Add them at the TOP of the array
2. Use the format "announcement-YYYY-MM-DD" for IDs
3. Ensure images are imported from the assets directory
4. Place images in: src/assets/images/
5. The most recent announcement will trigger the "NEW" badge for users
*/
